class travel_insurance {
  constructor() {
    this.items = [
      {
        id: 301,
        name: "Elite – Individual (Up to 10 Days)",
        badge: "Zone 1 · Individual",
        coverage: "150000",
        price: "22.55",
        bgColorClass: "bg-info",
        description: `<p><strong>Elite Plan – Zone 1 (Worldwide incl. USA/CAN/AUS)</strong></p>
<ul>
<li><strong>Coverage Duration:</strong> Up to 10 consecutive days</li>
<li><strong>Coverage Type:</strong> Individual</li>
<li><strong>Emergency Medical (Accident/Illness):</strong> Rs. 150,000</li>
<li><strong>COVID-19 Emergency Medical:</strong> Rs. 35,000</li>
<li><strong>Emergency Dental Care:</strong> Rs. 600 (Excess: Rs. 60)</li>
<li><strong>Medical Evacuation &amp; Repatriation:</strong> Actual Expenses</li>
<li><strong>Trip Cancellation:</strong> Rs. 1,000</li>
<li><strong>Loss of Checked-In Luggage:</strong> Rs. 1,000</li>
<li><strong>Accidental Death (Common Carrier):</strong> Rs. 30,000</li>
<li><strong>24/7 Assistance Services:</strong> Included</li>
</ul>
<p><em>* Final premium may vary based on age loading. Persons aged 66+ require health declaration.</em></p>`,
        type: "insurance",
      },
      {
        id: 302,
        name: "Elite – Individual (Up to 17 Days)",
        badge: "Zone 1 · Individual",
        coverage: "150000",
        price: "30.00",
        bgColorClass: "bg-warning",
        description: `<p><strong>Elite Plan – Zone 1 (Worldwide incl. USA/CAN/AUS)</strong></p>
<ul>
<li><strong>Coverage Duration:</strong> Up to 17 consecutive days</li>
<li><strong>Coverage Type:</strong> Individual</li>
<li><strong>Emergency Medical (Accident/Illness):</strong> Rs. 150,000</li>
<li><strong>COVID-19 Emergency Medical:</strong> Rs. 35,000</li>
<li><strong>Emergency Dental Care:</strong> Rs. 600 (Excess: Rs. 60)</li>
<li><strong>Medical Evacuation &amp; Repatriation:</strong> Actual Expenses</li>
<li><strong>Trip Cancellation:</strong> Rs. 1,000</li>
<li><strong>Loss of Checked-In Luggage:</strong> Rs. 1,000</li>
<li><strong>Accidental Death (Common Carrier):</strong> Rs. 30,000</li>
<li><strong>24/7 Assistance Services:</strong> Included</li>
</ul>
<p><em>* Final premium may vary based on age loading. Persons aged 66+ require health declaration.</em></p>`,
        type: "insurance",
      },
      {
        id: 303,
        name: "Elite – Individual (Up to 31 Days)",
        badge: "Zone 1 · Individual",
        coverage: "150000",
        price: "45.00",
        bgColorClass: "bg-info",
        description: `<p><strong>Elite Plan – Zone 1 (Worldwide incl. USA/CAN/AUS)</strong></p>
<ul>
<li><strong>Coverage Duration:</strong> Up to 31 consecutive days</li>
<li><strong>Coverage Type:</strong> Individual</li>
<li><strong>Emergency Medical (Accident/Illness):</strong> Rs. 150,000</li>
<li><strong>COVID-19 Emergency Medical:</strong> Rs. 35,000</li>
<li><strong>Emergency Dental Care:</strong> Rs. 600 (Excess: Rs. 60)</li>
<li><strong>Medical Evacuation &amp; Repatriation:</strong> Actual Expenses</li>
<li><strong>Trip Cancellation:</strong> Rs. 1,000</li>
<li><strong>Loss of Checked-In Luggage:</strong> Rs. 1,000</li>
<li><strong>Accidental Death (Common Carrier):</strong> Rs. 30,000</li>
<li><strong>24/7 Assistance Services:</strong> Included</li>
</ul>
<p><em>* Final premium may vary based on age loading. Persons aged 66+ require health declaration.</em></p>`,
        type: "insurance",
      },
      {
        id: 304,
        name: "Elite – Family (Up to 10 Days)",
        badge: "Zone 1 · Family",
        coverage: "150000",
        price: "45.10",
        bgColorClass: "bg-warning",
        description: `<p><strong>Elite Plan – Zone 1 (Worldwide incl. USA/CAN/AUS)</strong></p>
<ul>
<li><strong>Coverage Duration:</strong> Up to 10 consecutive days</li>
<li><strong>Coverage Type:</strong> Family (2 adults under 65 + unlimited children under 18, travelling together)</li>
<li><strong>Emergency Medical (Accident/Illness):</strong> Rs. 150,000</li>
<li><strong>COVID-19 Emergency Medical:</strong> Rs. 35,000</li>
<li><strong>Emergency Dental Care:</strong> Rs. 600 (Excess: Rs. 60)</li>
<li><strong>Medical Evacuation &amp; Repatriation:</strong> Actual Expenses</li>
<li><strong>Compassionate Visit:</strong> Rs. 100/day, Max Rs. 1,000</li>
<li><strong>Trip Cancellation:</strong> Rs. 1,000</li>
<li><strong>Loss of Checked-In Luggage:</strong> Rs. 1,000</li>
<li><strong>Accidental Death (Common Carrier):</strong> Rs. 30,000</li>
<li><strong>24/7 Assistance Services:</strong> Included</li>
</ul>
<p><em>* Base Premium: Rs. 45.10. Age loading applies for adults aged 66+. Final = Base × (1 + Age Loading %).</em></p>`,
        type: "insurance",
      },
      {
        id: 305,
        name: "Elite – Family (Up to 31 Days)",
        badge: "Zone 1 · Family",
        coverage: "150000",
        price: "80.00",
        bgColorClass: "bg-info",
        description: `<p><strong>Elite Plan – Zone 1 (Worldwide incl. USA/CAN/AUS)</strong></p>
<ul>
<li><strong>Coverage Duration:</strong> Up to 31 consecutive days</li>
<li><strong>Coverage Type:</strong> Family (2 adults under 65 + unlimited children under 18, travelling together)</li>
<li><strong>Emergency Medical (Accident/Illness):</strong> Rs. 150,000</li>
<li><strong>COVID-19 Emergency Medical:</strong> Rs. 35,000</li>
<li><strong>Emergency Dental Care:</strong> Rs. 600 (Excess: Rs. 60)</li>
<li><strong>Medical Evacuation &amp; Repatriation:</strong> Actual Expenses</li>
<li><strong>Compassionate Visit:</strong> Rs. 100/day, Max Rs. 1,000</li>
<li><strong>Trip Cancellation:</strong> Rs. 1,000</li>
<li><strong>Loss of Checked-In Luggage:</strong> Rs. 1,000</li>
<li><strong>Accidental Death (Common Carrier):</strong> Rs. 30,000</li>
<li><strong>24/7 Assistance Services:</strong> Included</li>
</ul>
`,
        type: "insurance",
      },
      {
        id: 306,
        name: "Elite – Family (Up to 62 Days)",
        badge: "Zone 1 · Family",
        coverage: "150000",
        price: "130.00",
        bgColorClass: "bg-warning",
        description: `<p><strong>Elite Plan – Zone 1 (Worldwide incl. USA/CAN/AUS)</strong></p>
<ul>
<li><strong>Coverage Duration:</strong> Up to 62 consecutive days</li>
<li><strong>Coverage Type:</strong> Family (2 adults under 65 + unlimited children under 18, travelling together)</li>
<li><strong>Emergency Medical (Accident/Illness):</strong> Rs. 150,000</li>
<li><strong>COVID-19 Emergency Medical:</strong> Rs. 35,000</li>
<li><strong>Emergency Dental Care:</strong> Rs. 600 (Excess: Rs. 60)</li>
<li><strong>Medical Evacuation &amp; Repatriation:</strong> Actual Expenses</li>
<li><strong>Compassionate Visit:</strong> Rs. 100/day, Max Rs. 1,000</li>
<li><strong>Trip Cancellation:</strong> Rs. 1,000</li>
<li><strong>Loss of Checked-In Luggage:</strong> Rs. 1,000</li>
<li><strong>Loss of Passport:</strong> Rs. 600</li>
<li><strong>Loss of Credit Card (first 24 hrs):</strong> Rs. 2,000</li>
<li><strong>Bail Bond Advance:</strong> Rs. 12,000</li>
<li><strong>Accidental Death (Common Carrier):</strong> Rs. 30,000</li>
<li><strong>24/7 Assistance Services:</strong> Included</li>
</ul>
`,
        type: "insurance",
      },
    ];

    this.terms = `
    <b style="font-size: 12px;">Disclaimer: </b><small style="font-size: 10px;"> Webdoc in partnership with our underwriter is providing this Travel Insurance product. Premium is subject to age loading as applicable.</small><br/><br/>

    <p><strong>AGE PREMIUM LOADING</strong></p>
    <ul>
      <li><strong>Up to 65 years:</strong> Standard Premium – No loading</li>
      <li><strong>66 – 75 years:</strong> +50% – Health declaration required</li>
      <li><strong>76 – 80 years:</strong> +75% – Health declaration required</li>
      <li><strong>81 – 85 years:</strong> +100% – Health declaration + SIMA preapproval</li>
      <li><strong>86 – 90 years:</strong> +200% – Health declaration + SIMA preapproval</li>
    </ul>
    <p><strong>Premium Formula:</strong> Final Premium = Base Premium × (1 + Age Loading %)</p>
    <p><em>Example: Base Rs. 45.10 × (1 + 200%) = Rs. 135.30</em></p>

    <p><strong>MEDICAL DEDUCTIBLE</strong></p>
    <ul>
      <li>Rs. 300 applies on all medical claims.</li>
    </ul>

    <p><strong>KEY CONDITIONS</strong></p>
    <ul>
      <li>Policy valid for insured aged 30 days – 85 years (86–90 requires SIMA preapproval).</li>
      <li>Maximum trip duration: 180 consecutive days per trip.</li>
      <li>Policy extension available up to 62 days (+100% of paid premium, 7-day waiting period applies).</li>
      <li>Family = 2 named adults under 65 + any number of children under 18, travelling together.</li>
      <li>COVID-19 covered only if PCR+ ≥72 hours after arrival at destination; max 10 days hospitalization.</li>
      <li>One-way tickets and open tickets are NOT covered; return ticket must be booked before departure.</li>
      <li>Claims must be submitted within 30 days of occurrence / first treatment.</li>
    </ul>

    <p><strong>EXCLUSIONS</strong></p>
    <ul>
      <li>Pre-existing, congenital, chronic, and psychiatric conditions are excluded.</li>
      <li>Cosmetic or elective procedures are not covered.</li>
      <li>War, civil commotion, riots, and nuclear/biological/chemical hazards are excluded.</li>
      <li>Injuries sustained under influence of alcohol or drugs are not covered.</li>
      <li>Travel against medical advice is not covered.</li>
    </ul>

    <p><strong>COVERAGE SUMMARY (Elite Plan – Zone 1)</strong></p>
    <ul>
      <li>Emergency Medical (Accident/Illness): Rs. 150,000</li>
      <li>COVID-19 Emergency Medical: Rs. 35,000 (all plans)</li>
      <li>Emergency Dental Care: Rs. 600 (Excess: Rs. 60)</li>
      <li>Medical Evacuation &amp; Repatriation: Actual Expenses</li>
      <li>Repatriation of Mortal Remains: Actual Expenses</li>
      <li>Compassionate Visit (Family Member): Rs. 100/day, Max Rs. 1,000</li>
      <li>Trip Cancellation: Rs. 1,000</li>
      <li>Delayed Departure: Rs. 1,000</li>
      <li>Loss of Checked-In Luggage: Rs. 1,000</li>
      <li>Loss of Passport: Rs. 600</li>
      <li>Loss of Credit Card (first 24 hrs): Rs. 2,000</li>
      <li>Accidental Death (Common Carrier): Rs. 30,000</li>
      <li>Bail Bond Advance: Rs. 12,000</li>
      <li>24/7 Assistance Services: Included</li>
    </ul>
`;
  }

  getAllItems() {
    return this.items;
  }

  getTerms() {
    return this.terms;
  }
}

export default travel_insurance;
